import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import intl from 'react-intl-universal';
import { Container } from './styles';
import logger from 'utils/logger';
import { useSnackbar } from 'notistack';

const log = logger.createLogger('IssueDetailsReportsReportDropZone');

const propTypes = {
  handleFiles: PropTypes.func.isRequired,
};

export const imageExtension = new Set(['jpg', 'jpeg', 'png']);

// Limit the file type and change the file zone message

const ReportDropZone = ({ handleFiles }) => {
  const { enqueueSnackbar } = useSnackbar();

  // Only allow image files
  const handleOnDrop = (files) => {
    const file = files[0];
    const fileExtension = file.name.split('.').pop();
    if (!imageExtension.has(fileExtension)) {
      enqueueSnackbar(intl.get('new_text_dropzone_message_error'), {
        variant: 'error',
        autoHideDuration: 1000,
      });
      return;
    }
    handleFiles(files);
  };

  return (
    <Dropzone onDrop={handleOnDrop}>
      {({ getRootProps, getInputProps }) => {
        return (
          <div {...getRootProps()}>
            <input {...getInputProps()} data-testid="file-input" />
            <Container>
              <span>{intl.get('new_text_dropzone_message')}</span>
              <span
                style={{
                  fontSize: '12px',
                  opacity: 0.7,
                  marginTop: '5px',
                  display: 'block',
                }}>
                {intl.get('new_text_dropzone_message_details')}
              </span>
            </Container>
          </div>
        );
      }}
    </Dropzone>
  );
};

ReportDropZone.propTypes = propTypes;

export default ReportDropZone;
